import { EventEmitter, Injectable } from '@angular/core';
import { CanvasService } from './canvas.service';
import { CanvasInputModeService } from './canvas-input-mode.service';

@Injectable({
    providedIn: 'root',
})
export class SelectedElementsService {
    private _onElementsSelected = new EventEmitter<SVGElement[]>();

    constructor(
        private canvas: CanvasService,
        private canvasInputService: CanvasInputModeService
    ) {}

    init(): void {
        this.canvas.getCanvas().bind('selected', (win, elems) => {
            this.emitElementsSelected(elems);
        });
        this.setSelectedElements([]);
    }

    onElementsSelected() {
        return this._onElementsSelected;
    }

    private emitElementsSelected(elements) {
        this._onElementsSelected.emit(elements);
    }

    setSelectedElements(elements: SVGGraphicsElement[]) {
        this.canvas.getCanvas().selectOnly(elements, true);
    }

    setSelectedElementsForSaveButton(elements: SVGGraphicsElement[]) {
        this.canvas.getCanvas().selectOnly(elements, true);
        this.emitElementsSelected(elements);
        this.canvasInputService.setMode(this.canvasInputService.getMode());
    }

    getSelectedElements(): SVGGraphicsElement[] {
        return this.canvas.getCanvas().getSelectedElements();
    }
}
